module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av294-9a5554b3d871445d921d14eb26d31aa8.jpg";